<template>
  <div class="header-bar">
    <button
        type="button"
        class="header-icon hidden-md hidden-lg"
        @click="$emit('toggleMenu')"
        aria-label="Expand Menu"
    >
    </button>
    <a
        :href="`${glb.appUrl}${getLangPathPrefix}`"
        title="Movoto Logo"
        :class="['header-logo', {'hidden-xs hidden-sm': !disableSearch}]"
        aria-label="Movoto Home"
    ></a>
    <slot />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'mvtHeaderLogo',
    emits: ['toggleMenu'],
    props: ['disableSearch'],
    computed: {
        ...mapGetters('glb', ['glb', 'getLangPathPrefix']),
    },
};
</script>